import { transitionToPromise } from '../../utils/utils'
import { BaseComponent } from '../base-component'

export class TabComponent extends BaseComponent {
  async show(): Promise<void> {
    await this.setVisible(true)
  }

  async hide(): Promise<void> {
    await this.setVisible(false)
  }

  async setVisible(isVisible: boolean): Promise<void> {
    this.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
    await transitionToPromise(this)
  }

  get isVisible(): boolean {
    return this.getAttribute('aria-hidden') === 'false'
  }
}
